// extracted by css-extract-rspack-plugin
export default {"card":"GdBqE3JDMdY0ZfPA","grid":"XrJXV3SkpwQz4aJL"};